import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {HtmlEditor} from "../editor/HtmlEditor";
import {ProseArticle} from "../app/ProseArticle";

export const RichEditor = ({initialData, onSave, onCancel}) => {
    const [editorState, setEditorState] = useState("");

    useEffect(() => {
        setEditorState(initialData || "");
    }, [initialData]);

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: 3}}>
            <Paper
                variant="outlined"
                sx={{
                    borderRadius: 3,
                    borderColor: "divider",
                    p: {xs: 2, sm: 3},
                    bgcolor: "#FFFFFF",
                }}
            >
                <HtmlEditor
                    value={editorState}
                    onChange={setEditorState}
                />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 1.5,
                        pt: 2.5,
                        mt: 2,
                        borderTop: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Button
                        color="inherit"
                        onClick={onCancel}
                        startIcon={<CloseIcon />}
                        sx={{
                            minHeight: 44,
                            px: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            borderRadius: 2,
                            "&:focus-visible": {
                                outline: "2px solid",
                                outlineColor: "primary.main",
                                outlineOffset: 2,
                            },
                        }}
                    >
                        Avbryt
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onSave(editorState)}
                        startIcon={<SaveIcon />}
                        sx={{
                            minHeight: 44,
                            px: 3,
                            textTransform: "none",
                            fontWeight: 700,
                            borderRadius: 2,
                            boxShadow: "none",
                            "&:hover": {
                                boxShadow: "0 4px 12px rgba(40, 82, 56, 0.2)",
                            },
                            "&:focus-visible": {
                                outline: "2px solid",
                                outlineColor: "primary.main",
                                outlineOffset: 2,
                            },
                        }}
                    >
                        Lagre
                    </Button>
                </Box>
            </Paper>

            <Paper
                variant="outlined"
                sx={{
                    p: {xs: 2.5, sm: 4},
                    borderRadius: 3,
                    borderColor: "rgba(40, 82, 56, 0.15)",
                    bgcolor: "rgba(250, 248, 245, 0.6)",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 2,
                        pb: 1,
                        borderBottom: "1px dashed rgba(40, 82, 56, 0.2)",
                    }}
                >
                    <VisibilityIcon sx={{fontSize: 20, color: "primary.main"}} />
                    <Typography
                        variant="subtitle2"
                        component="h3"
                        sx={{
                            fontWeight: 700,
                            color: "primary.main",
                            textTransform: "uppercase",
                            letterSpacing: 0.8,
                            fontSize: "0.8rem",
                        }}
                    >
                        Forhåndsvisning
                    </Typography>
                </Box>
                <ProseArticle html={editorState} />
            </Paper>
        </Box>
    );
};